module.exports = __webpack_public_path__ + "img/arrow-up.b03cba35.svg";